import script from "./DinteroTestHelper.vue?vue&type=script&setup=true&lang=js"
export * from "./DinteroTestHelper.vue?vue&type=script&setup=true&lang=js"

import "./DinteroTestHelper.vue?vue&type=style&index=0&id=e3d06212&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3d06212"]])

export default __exports__